const vision = 'https://ik.imagekit.io/59olwmt4e/tr:w-650/vision.jpg';
const videoCover = 'https://ik.imagekit.io/59olwmt4e/tr:w-600/video-cover.jpg';
const child = 'https://ik.imagekit.io/59olwmt4e/about-child.jpg';
const pageHeaderImage = 'https://ik.imagekit.io/59olwmt4e/news-hero.jpg';
const pgHeaderImgSrcSet =
	'https://ik.imagekit.io/59olwmt4e/tr:w-400/news-hero.jpg 400w, https://ik.imagekit.io/59olwmt4e/tr:w-600/news-hero.jpg 600w, https://ik.imagekit.io/59olwmt4e/tr:w-900/news-hero.jpg 900w, https://ik.imagekit.io/59olwmt4e/news-hero.jpg';

export { pageHeaderImage, pgHeaderImgSrcSet, videoCover, child, vision };
